<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi"><a id="page_5"><span class="bold">To Alex Jackinson agent, adviser, friend, with gratitude</span></a><a id="page_6"></a></p><a id="page_6">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedi.vue?4f5d3c8c